import React from 'react'
import PropTypes from 'prop-types'
import classes from './index.module.css'
import CreateTeamDynamicInputsTextFields from '../../CreateTeamDynamicInputsTextFields'

export default function Step({ setData, type, label = 'Team Member' }) {
  const onArrayChange = newOwners =>
    setData(prev => {
      return {
        ...prev,
        owners: newOwners,
      }
    })

  return (
    <div className={classes.wrapper}>
      <CreateTeamDynamicInputsTextFields
        placeholder={'Enter email'}
        label={label}
        onChange={onArrayChange}
        type={type}
      />
    </div>
  )
}

Step.propTypes = {
  setData: PropTypes.func,
  label: PropTypes.string,
  type: PropTypes.oneOf(['team', 'organization']),
}
